import React from 'react';
import ReactComponentType from '@configuratorware/configurator-frontendgui/Shared/PropTypes/ReactComponent';
import { DesignerScreen } from '@configuratorware/configurator-frontendgui/App/Modules/Designer/DesignerScreen';
import PropTypes from 'prop-types';
// import FullScreenView from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Components/FullScreenView/FullScreenView';

import {
  DefaultCanvasProvider,
  DefaultCanvasStateProvider,
  DefaultTextEditorStateProvider,
} from '@configuratorware/configurator-frontendgui/App/Shared/Providers/DefaultCanvasProvider';
import ScreenPropTypes from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ScreenPropTypes';
import { PopupArea as DefaultPopupArea } from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Layouts/PopupAreaProvider';

import EditDesignButton from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/EditDesignButton';
import CloseGraphicsEditorButton from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/CloseGraphicsEditorButton';
import CloseDesignEditor from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/CloseDesignEditor';

import DesignAreaControlbox from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/DesignAreaControlbox';
import ImageEditDialog from './Containers/ImageEditDialog';
import { DesignerAlignTarget } from '../Visualization/DesignerAlignTarget';

import DesignerSelectionToolbox from './Containers/DesignerSelectionToolbox';
import Designer from './Containers/Designer';
import AddVisualElement from './Containers/AddVisualElement';
import DesignPicker from './Containers/DesignPicker';
import MobilePickerMenu from './Containers/MobilePickerMenu';
import ResetRow from '../Creator/Containers/ResetRow';
import FullScreenView from './Components/FullScreenView/FullScreenView';
import DefaultLayout from './Layouts/DefaultLayout';
import Header from '../../Shared/Containers/Header';
import FallbackVisualization from '../../Screens/Configurator/Containers/FallbackVisualization';
import Progress from '../../Shared/Components/Progress/Progress';

export function CustomDesignerScreen(props) {
  const {
    showDesigner,
    fallbackMode,
    is3DvisualMode,
    isPortraitMode,
    renderSaveConfiguration,
    renderSendEmail,
    renderPdfDownload,
    renderLoadConfiguration,
    renderError,
    renderAlertMessages,
    renderConfirm,
    renderAmountPrice,
    renderDesigner,
    renderDesignerSelectionToolbox,
    renderDesignerFallback,
    renderVisualization,
    renderImageEditDialog,
    renderCloseDesignEditor,
    renderAddVisualElement,
    renderLoader,
    renderLicenseNotice,
    customElements,

    // Components
    CanvasProvider,
    CanvasStateProvider,
    TextEditorStateProvider,
    PopupArea,
  } = props;

  const renderHeader = () => <Header />;

  // {renderAmountPrice(props)}rrender
  return (
    <>
      <CanvasProvider>
        <DefaultLayout
          isPortraitMode={isPortraitMode}
          renderHeader={(renderProps) => (renderProps.width === 'xs' && showDesigner ? () => <div /> : renderHeader())}
          fallbackMode={false}
          renderVisualization={() => renderVisualization({
            fullScreenViewProps: {
              Component: FullScreenView,
              showPreviewButton: !showDesigner,
              thumbnailDotMode: true,
              renderButtonOnTop: false,
            },
          })}
          renderDesignPicker={(renderProps) => (
            <>
              <DesignPicker
                {...renderProps}
              />
              <ResetRow />
              <CanvasStateProvider>
                <React.Suspense fallback={renderDesignerFallback()}>
                  <>
                    {renderAddVisualElement()}
                  </>
                </React.Suspense>
              </CanvasStateProvider>
            </>
          )}
          renderMain={(renderProps) => (
            <>

              {/* renderEditDesignButton({ styledButton: false }) */}

              <DesignerAlignTarget />
              <FallbackVisualization fallbackMode={fallbackMode} showContent={showDesigner}>
                {showDesigner && renderDesigner()}
              </FallbackVisualization>
              <CanvasStateProvider>
                <MobilePickerMenu {...props} />
              </CanvasStateProvider>
              {renderError()}
              {renderAlertMessages()}
              {renderConfirm()}
              {renderSaveConfiguration()}
              {renderSendEmail()}
              {renderPdfDownload()}
              {renderLoadConfiguration()}
              {renderImageEditDialog()}
              {renderProps.width !== 'xs'
                            && showDesigner
                            && is3DvisualMode
                            && renderCloseDesignEditor()}
              {customElements.main}
            </>
          )}
          renderSidebar={(renderProps) => (

            <CanvasStateProvider>
              <TextEditorStateProvider>
                <PopupArea>
                  {renderDesignerSelectionToolbox()}
                </PopupArea>
              </TextEditorStateProvider>
            </CanvasStateProvider>
          )}
          renderLoader={renderLoader}
          renderLicenseNotice={renderLicenseNotice}
        />
      </CanvasProvider>

      {renderAmountPrice(props)}
    </>
  );
}

CustomDesignerScreen.propTypes = {
  ...ScreenPropTypes,

  showProductViewButton: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  showPreviewButton: PropTypes.bool,
  area: PropTypes.string,
  customElements: PropTypes.shape({
    main: PropTypes.node,
  }),

  // Render props
  renderDesignerSelectionToolbox: PropTypes.func,
  renderVisualizationEdit: PropTypes.func,
  renderDesignerFallback: PropTypes.func,

  renderHeader: PropTypes.func,
  renderDesignAreaControlbox: PropTypes.func,
  renderEditDesignButton: PropTypes.func,
  renderCloseGraphicsEditorButton: PropTypes.func,
  renderImageEditDialog: PropTypes.func,
  renderCloseDesignEditor: PropTypes.func,
  renderAddVisualElement: PropTypes.func,

  // Components
  CanvasProvider: ReactComponentType.isRequired,
  CanvasStateProvider: ReactComponentType.isRequired,
  TextEditorStateProvider: ReactComponentType.isRequired,
  Layout: ReactComponentType.isRequired,
  PopupArea: ReactComponentType.isRequired,
};

// eslint-disable-next-line react/prop-types
const renderDesignAreaControlbox = ({ area }) => <DesignAreaControlbox boxed={area === 'sidebar'} />;

// eslint-disable-next-line react/prop-types
const renderEditDesignButton = ({ styledButton }) => <EditDesignButton buttonXS={styledButton} />;

CustomDesignerScreen.defaultProps = {
  // Render props
  renderCreator: () => null,
  renderDesigner: () => (
    <React.Suspense fallback={<div>Loading Designer Component...</div>}>
      <Designer />
    </React.Suspense>
  ),
  renderDesignerSelectionToolbox: () => (
    <React.Suspense fallback={<div>Loading Designer Toolbox...</div>}>
      <DesignerSelectionToolbox />
    </React.Suspense>
  ),
  renderHeader: () => <Header />,
  renderDesignerFallback: () => <div>Loading Designer Component...</div>,
  renderCloseGraphicsEditorButton: () => <CloseGraphicsEditorButton />,
  renderImageEditDialog: () => <ImageEditDialog ProgressComponent={Progress} />,
  renderCloseDesignEditor: () => <CloseDesignEditor />,
  renderAddVisualElement: () => <AddVisualElement />,
  renderEditDesignButton,
  renderDesignAreaControlbox,

  // Components
  CanvasProvider: DefaultCanvasProvider,
  CanvasStateProvider: DefaultCanvasStateProvider,
  TextEditorStateProvider: DefaultTextEditorStateProvider,
  Layout: DefaultLayout,
  PopupArea: DefaultPopupArea,
};
export default CustomDesignerScreen;
